<ng-container *transloco="let t">
  <div class="row pb-48-36">
    <div class="col-12 col-xxl-6">
      <div>
        <div class="pb-20">
          <app-grid-item-title [title]="t('app.landing.upcoming.events')"/>
        </div>
        <app-event-list-item [languages]="languages" />
        <app-event-list-item [languages]="languages" [wspayConfirmation]="wspayConfirmation" />
        <app-event-list-item [languages]="languages" />
      </div>
    </div>
    <div class="col-12 col-xxl-6">
      <div>
        <div class="pb-20">
          <app-grid-item-title [title]="t('page.header.my.finished.events')"/>
        </div>
        <app-event-list-item [isFinishedEvent]="true" [languages]="languages" />
        <app-event-list-item [isFinishedEvent]="true" [languages]="languages" />
        <app-event-list-item [isFinishedEvent]="true" [languages]="languages" />
      </div>
    </div>
  </div>
</ng-container>
